<template>
    <div class="animated fadeIn" v-if="satisfiedDependencies">
        <b-row class="py-2">
            <b-card header="Ficha Usuario" class="w-100">
                <b-form @submit.prevent="store" autocomplete="off">
                    <b-row class="pb-2">
                        <b-col sm="12" md="4">
                            <b-form-group>
                                <label for="username"><strong>Nombre de Usuario *</strong></label>
                                <b-input-group>
                                    <b-input-group-prepend>
                                        <b-input-group-text><i class="fa fa-user"></i></b-input-group-text>
                                    </b-input-group-prepend>
                                    <b-form-input
                                        type="text"
                                        id="username"
                                        placeholder="Introduzca nombre de usuario"
                                        v-model="user.username"
                                        :required="true"
                                        autocomplete="new-username">
                                        <i class="fa fa-user"></i>
                                    </b-form-input>
                                </b-input-group>
                            </b-form-group>
                        </b-col>

                        <b-col sm="12" md="4">
                            <b-form-group>
                                <label for="password"><strong>Contraseña *</strong></label>
                                <b-input-group>
                                    <b-input-group-prepend>
                                        <b-input-group-text><i class="fa fa-asterisk"></i></b-input-group-text>
                                    </b-input-group-prepend>
                                    <b-form-input
                                        :state="validPassword"
                                        :type="visible ? 'text' : 'password'"
                                        id="password"
                                        placeholder="Introduzca contraseña"
                                        v-model="user.password"
                                        autocomplete="new-password"
                                        required></b-form-input>
                                    <b-input-group-append @click="visible = !visible">
                                        <b-input-group-text class="bg-white border-left-0">
                                            <i class="fa fa-eye"></i>
                                        </b-input-group-text>
                                    </b-input-group-append>
                                    <div class="invalid-feedback" v-if="!validPassword">
                                        <small class="form-text text-danger">
                                            Mayúscula, minúscula, número y símbolo.
                                        </small>
                                    </div>

                                </b-input-group>
                            </b-form-group>
                        </b-col>

                        <b-col sm="12" md="4">
                            <b-form-group>
                                <label for="email"><strong>Email *</strong></label>
                                <b-input-group>
                                    <b-input-group-prepend>
                                        <b-input-group-text><i class="fa fa-envelope"></i></b-input-group-text>
                                    </b-input-group-prepend>
                                    <b-form-input
                                        type="email"
                                        id="email"
                                        placeholder="Introduzca email"
                                        autocomplete="off"
                                        v-model="user.email"
                                        required>
                                        <i class="fa fa-email" required></i>
                                    </b-form-input>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="12" md="6" lg="4">
                            <b-form-group
                                label="<strong>Nombre *</strong>"
                                label-for="firstname"
                                :horizontal="false"
                                class="w-100">
                                <b-form-input
                                    id="firstname"
                                    type="text"
                                    placeholder="Nombre"
                                    v-model="user.firstname"
                                    autocomplete="off"></b-form-input>
                            </b-form-group>
                            <b-form-group
                                label="<strong>Apellidos *</strong>"
                                label-for="lastname"
                                :horizontal="false" class="w-100">
                                <b-form-input
                                    id="lastname"
                                    type="text"
                                    placeholder="Apellidos"
                                    v-model="user.lastname"
                                    autocomplete="off"></b-form-input>
                            </b-form-group>
                            <b-form-group
                                label="<strong>Sexo</strong>"
                                label-for="sex"
                                :horizontal="false" class="w-100">
                                <multiselect
                                    name="sex"
                                    v-model="user.sex"
                                    :options="sex.map(type => type.value)"
                                    :custom-label="opt => sex.find(x => x.value == opt).label"
                                    selectLabel="+"
                                    deselectLabel="-"
                                    placeholder="Seleccione opción"></multiselect>
                            </b-form-group>
                            <b-form-group
                                label="<strong>Teléfono</strong>"
                                label-for="phone"
                                :horizontal="false" class="w-100">
                                <b-form-input
                                    id="phone"
                                    type="text"
                                    placeholder="Fijo o móvil"
                                    v-model="user.phone"
                                    autocomplete="off"></b-form-input>
                                <div v-if="!validatePhone() && user.phone">
                                    <small class="form-text text-danger">
                                        No válido
                                    </small>
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="6" lg="4">
                            <b-form-group
                                label="<strong>Roles</strong>"
                                label-for="roles"
                                :horizontal="false"
                                class="w-100">
                                <multiselect
                                    name="roles"
                                    v-model="user.roles"
                                    :options="roles"
                                    label="description"
                                    track-by="uuid"
                                    :multiple="true"
                                    :allowEmpty="true"
                                    placeholder="Seleccione"
                                    selectLabel="+"
                                    deselectLabel="-">
                                </multiselect>
                            </b-form-group>
                            <b-form-group
                                class="animated fadeIn"
                                v-if="hasAdvisoryRoles && topLevelQueryCategories.length">
                                <label for="specialty"><strong>Especialidad</strong></label>
                                <multiselect
                                    id="specialty"
                                    v-model="user.specialtyId"
                                    :options="topLevelQueryCategories.map(type => type.uuid)"
                                    :multiple="false"
                                    :allowEmpty="true"
                                    :custom-label="opt => topLevelQueryCategories.find(x => x.uuid  === opt).name"
                                    placeholder="Seleccione opción"
                                    selectLabel="+"
                                    deselectLabel="-"></multiselect>
                            </b-form-group>
                            <b-form-group
                                label="<strong>Delegación *</strong>"
                                label-for="delegation"
                                :horizontal="false" class="w-100" v-if="headquarters">
                                <multiselect
                                    name="delegation"
                                    v-model="user.delegationId"
                                    :options="headquarters.map(type => type.uuid)"
                                    :multiple="false"
                                    :allowEmpty="false"
                                    :custom-label="opt => headquarters.find(x => x.uuid  === opt).name"
                                    placeholder="Seleccione opción"
                                    selectLabel="+"
                                    deselectLabel="-"
                                    required></multiselect>
                            </b-form-group>
                            <b-form-group
                                label="<strong>Departamento *</strong>"
                                label-for="department"
                                :horizontal="false"
                                class="w-100 animated fadeIn"
                                v-if="!!this.departments.departments && departments.departments.length">
                                <multiselect
                                    name="department"
                                    v-model="user.departmentId"
                                    :options="departments.departments.map(type => type.uuid)"
                                    :multiple="false"
                                    :allowEmpty="true"
                                    :custom-label="opt => departments.departments.find(x => x.uuid == opt).code"
                                    placeholder="Seleccione opción"
                                    selectLabel="+"
                                    deselectLabel="-"
                                    required></multiselect>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="6" lg="4">
                            <b-form-group
                                label="<strong>Sedes Gestionadas *</strong>"
                                label-for="headquarters"
                                :label-cols="3" v-if="headquarters">
                                <b-form-checkbox-group
                                    stacked
                                    id="headquarters"
                                    name="headquarters"
                                    v-model="user.headquarters">
                                    <template v-for="headquarter in headquarters">
                                        <b-form-checkbox :value="headquarter.uuid">
                                            {{ headquarter.name }}
                                        </b-form-checkbox>
                                    </template>
                                </b-form-checkbox-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <div class="col float-left">
                            <button
                                type="submit"
                                class="btn btn-brand btn-primary btn-lg pull-right"
                                :disabled="!generalValidate()"
                                v-if="mixinCheckPermission('USER_NEW')">
                                Guardar
                            </button>
                        </div>
                    </b-row>
                </b-form>
            </b-card>
        </b-row>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import form from "@/helpers/form";
    import {getRoles} from '@/api/role-api';
    import {getQueryCategories} from '@/api/query-category-api';
    import {isAdvisoryRole} from '@/helpers/role-helper'

    export default {
        name: 'addUsers',
        components: {
            Multiselect,
        },
        mounted() {
            this.$eventHub.$emit('captureMenu', this.topmenu);
            this.getGeneral("headquarters", "headquarters");
            this.getRoles();
            this.getQueryAnswerTypes();
        },
        data: function () {
            return {
                topmenu: [
                    {name: 'Volver', path: '/admin/user/list', brand: 'fa fa-arrow-left'},
                ],
                departments: [],
                headquarters: [],
                roles: [],
                queryCategories: [],
                user: {
                    username: null,
                    password: null,
                    email: null,
                    firstname: null,
                    lastname: null,
                    sex: null,
                    phone: null,
                    roles: [],
                    departmentId: null,
                    delegationId: null,
                    headquarters: [],
                    specialtyId: null
                },
                sex: [
                    {label: "Hombre", value: "1"},
                    {label: "Mujer", value: "2"},
                    {label: "Otra opción", value: "3"},
                ],
                visible: false,
                validPassword: null,
            }
        },
        computed: {
            satisfiedDependencies() {
                return (this.headquarters.length);
            },
            topLevelQueryCategories() {
                return this.queryCategories.filter((category) => (category.parent === undefined));
            },
            hasAdvisoryRoles() {
                return !!this.user.roles.find((role) => (isAdvisoryRole(role.name) === true));
            }
        },
        methods: {
            store() {
                this.$_loadingMixin_showLoading();
                let properties = Object.assign({}, this.user);
                properties.roles = properties.roles.map((role) => (role.uuid));
                if (!this.hasAdvisoryRoles) {
                    properties.specialtyId = null;
                }
                axios.post('users', properties)
                    .then((response) => {
                        this.$_loadingMixin_hideLoading();
                        if (response.status == "201") {
                            this.$_notificationMixin_success('Operación Completada', 'Realizado con éxito');
                            this.$router.push({path: '/admin/user/list'});
                        }
                    })
                    .catch((error) => {
                        this.$_loadingMixin_hideLoading();
                        this.showApiError(error.response);
                    });
            },
            async getGeneral(url, varName) {
                try {
                    this.$_loadingMixin_showLoading();
                    const response = await axios.get(url);
                    this.$_loadingMixin_hideLoading();
                    if (response.status == "200") {
                        this[varName] = response.data;
                    }
                } catch (error) {
                    this.showErrorMsg();
                }
            },
            async getRoles() {
                this.$_loadingMixin_showLoading();
                await getRoles()
                    .then((roles) => {
                        this.roles = roles;
                    });
                this.$_loadingMixin_hideLoading();
            },
            async getQueryAnswerTypes() {
                this.$_loadingMixin_showLoading();
                await getQueryCategories()
                    .then((queryCategories) => {
                        this.queryCategories = queryCategories;
                    });
                this.$_loadingMixin_hideLoading();
            },
            checkPassword() {
                let re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/;
                return re.test(this.user.password);
            },
            validatePhone() {
                return form.phone(this.user.phone);
            },
            generalValidate() {
                if (!this.user.username || !this.user.email || !this.user.delegationId || !this.user.departmentId || !this.checkPassword()) {
                    return false;
                } else if (this.user.phone && !this.validatePhone(this.user.phone)) {
                    return false;
                } else {
                    return true;
                }
            },
            showApiError(response) {
                if (response.status == 400) {
                    debugger;
                    let message = response.data;
                    if (message === "Email already exist") {
                        this.$_notificationMixin_error('Email incorrecto', 'El email introducido ya existe');
                    } else if (message === "Username already exist") {
                        this.$_notificationMixin_error('Nombre de usuario incorrecto', 'El nombre de usuario introducido ya existe');
                    }
                } else {
                    this.$_notificationMixin_error('Error al guardar el usuario', 'Algo salió mal');
                }
            }
        },
        watch: {
            'user.password': function () {
                if (this.checkPassword()) {
                    this.validPassword = true;
                } else {
                    this.validPassword = false;
                }
            },
            'user.delegationId': function () {
                if (this.user.delegationId) {
                    this.getGeneral("headquarter/" + this.user.delegationId, "departments");
                }
            }
        }
    }
</script>